export enum StorageKey {
  Theme = "theme",
  Locale = "locale",
  MusicCookies = "musicCookies",
  PhotoMode = "photoMode",
}
